// extracted by mini-css-extract-plugin
export var header = "ServicesHeader-module--header--10fcd";
export var paddingContainerServices = "ServicesHeader-module--padding-container-services--45e2e";
export var servicesHeaderContainer = "ServicesHeader-module--services-header-container--a2b26";